import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  DualIcon,
  FormFieldSet,
  NoData,
  PageTitle,
  SmartTooltip,
} from "../../../../components";
import AddNoteModal from "../../ConfirmedStart/Confirmed/modals/AddNoteModal";
import { fetchAllNotes } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { formatWords2 } from "../../../../utils/stringUtils";
import { dateFormator } from "../../../../utils";
import { convertFromUTC } from "../../../../utils/dateUtils";

const TableGridToggleView = ({
  gridData,
  onSelectionChange,
  selectedData,
  setDetailsDrawer,
  setCareerBuilderCurrentApplicantId,
  setCurrentApplicantId,
  source,
}) => {
  const [selected, setSelected] = useState(selectedData || []);
  const [noteModal, setNotesModal] = useState(false);
  const [noteData, setNotesData] = useState({});
  const [hoveredNotes, setHoveredNotes] = useState([]);
  const {
    totalApplicantsData: totalApplicants,
    totalApplicantsCount,
    totalRecords,
    careerBuilder,
  } = useSelector((state) => state.internalDbES);
  const {
    total,
    tableResponse,
    fullResponse,
    existingCandidates: existingCandidatesCB = [],
  } = careerBuilder;
  //console.log(existingCandidatesCB);

  useEffect(() => {
    setSelected(selectedData || []);
  }, [selectedData]);
  
  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id],
    );
  };
  const handleSelectAll = () => {
    if (selected.length === gridData.length) {
      setSelected([]);
    } else {
      setSelected(gridData.map((row) => row.id ?? row.applicantId));
    }
  };
  useEffect(() => {
    setSelected(selectedData || []);
  }, [selectedData]);
  useEffect(() => {
    if (onSelectionChange) {
      onSelectionChange(selected);
    }
  }, [selected]);

  const getHoveredNotes = async (notes) => {
    setHoveredNotes([]);
    try {
      const res = await fetchAllNotes({
        coll: "Note",
        pg: 1,
        lim: 2,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: notes } },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
      });

      if (res?.data) {
        setHoveredNotes(res.data.data || []);
      } else {
        setHoveredNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
    }
  };

  return (
    // <div className="flex-grow max-h-[70vh] overflow-y-auto p-4">
    <div className="flex-grow overflow-y-auto p-4">
      {/* Select All Checkbox */}
      {gridData?.length ? (
        <div className="mb-2 flex items-center gap-2">
          <FormFieldSet
            type="checkbox"
            noTitle
            options={[{ label: "", value: "all" }]}
            values={selected.length === gridData.length ? ["all"] : []}
            onChange={handleSelectAll}
            multiple
          />
          <span className="text-[14px] text-neutrals-500">Select all</span>
        </div>
      ) : (
        ""
      )}

      {gridData?.length ? (
        <div className="flex flex-col gap-2">
          {gridData?.map((data) => (
            <div
              key={data.id ? data?.id : data?.applicantId}
              className="flex items-start border-gray-300 border rounded-md p-3 shadow-lg bg-white relative"
            >
              {/* Left Section */}
              <div className="flex items-start gap-3">
                <FormFieldSet
                  type="checkbox"
                  noTitle
                  options={[
                    {
                      label: "",
                      value: data.id ? data?.id : data?.applicantId,
                    },
                  ]}
                  values={
                    selected.includes(data.id ? data?.id : data?.applicantId)
                      ? [data.id ? data?.id : data?.applicantId]
                      : []
                  }
                  onChange={() =>
                    handleSelect(data.id ? data?.id : data?.applicantId)
                  }
                  multiple
                />
                {existingCandidatesCB?.some((c) =>
                  (c?.resumeIds || []).some((r) => r?.id === data?.resumeId),
                ) && (
                  <div className="absolute right-0 top-0 p-2 text-primary-500 text-sm bg-primary-50">
                    Profile Migrated
                  </div>
                )}

                <div>
                  <div className="flex items-center flex-wrap gap-[2px] lg:flex-nowrap">
                    <PageTitle title={data?.name} tag="h5" />

                    {data?.uiid && (
                      <SmartTooltip description={"Migrated"} noicon>
                        <Button
                          type="icon"
                          size="sm"
                          variant="text"
                          icon="save"
                          color="black"
                        />
                      </SmartTooltip>
                    )}

                    {existingCandidatesCB?.some((c) =>
                      (c?.resumeIds || []).some(
                        (r) => r?.id === data?.resumeId,
                      ),
                    ) && (
                      <SmartTooltip description="Migrated" noicon>
                        <Button
                          type="icon"
                          size="sm"
                          variant="text"
                          icon="save"
                          color="black"
                        />
                      </SmartTooltip>
                    )}

                    <SmartTooltip description={"View Resume"} noicon>
                      <Button
                        type="icon"
                        size="sm"
                        variant="text"
                        icon="visibility"
                        color="black"
                        onClick={() => {
                          setDetailsDrawer(true);
                          if (source === 1) {
                            setCurrentApplicantId(data?.uiid);
                          }
                          if (source === 2) {
                            setCareerBuilderCurrentApplicantId(
                              data?.applicantId,
                            );
                          }
                        }}
                      />
                    </SmartTooltip>

                    {data.notes && data.notes.length > 0 && (
                      <div
                        onMouseEnter={() =>
                          data?.notes?.length > 0
                            ? getHoveredNotes(data?.notes)
                            : {}
                        }
                        onMouseLeave={() => setHoveredNotes([])}
                      >
                        <SmartTooltip
                          description={
                            Array.isArray(hoveredNotes) &&
                            hoveredNotes?.length > 0 ? (
                              <div className="flex flex-col gap-2">
                                {hoveredNotes?.map((hoveredNote, i) => (
                                  <p key={i}>
                                    "{hoveredNote?.note || ""}" by{" "}
                                    {formatWords2(
                                      hoveredNote?.addedBy?.firstName,
                                    ) || ""}{" "}
                                    on{" "}
                                    {dateFormator(
                                      convertFromUTC(hoveredNote?.addedOn),
                                      "datetime-ampm",
                                    ) || ""}
                                  </p>
                                ))}
                              </div>
                            ) : (
                              "Add note"
                            )
                          }
                          noicon
                        >
                          <DualIcon
                            icon="chat"
                            size="sm"
                            badgeIconColor={
                              data?.notes?.length > 0 ? "bg-success" : "bg-dark"
                            }
                            onClick={() => {
                              setNotesModal(true);
                              setNotesData({ uiid: data?.uiid });
                            }}
                          />
                        </SmartTooltip>
                      </div>
                    )}

                    {existingCandidatesCB?.find((c) =>
                      (c?.resumeIds || []).some(
                        (r) => r?.id === data?.resumeId,
                      ),
                    )?.notes?.length > 0 && (
                      <div
                        onMouseEnter={() => {
                          const isMatched = existingCandidatesCB?.find((c) =>
                            (c?.resumeIds || []).some(
                              (r) => r?.id === data?.resumeId,
                            ),
                          );
                          const uiids = isMatched?.notes
                            .filter(
                              (n) => n && typeof n === "object" && n?.uiid,
                            )
                            .map((n) => n.uiid);

                          const others = isMatched?.notes.filter(
                            (n) => !(n && typeof n === "object" && n?.uiid),
                          );
                          const merged = [...uiids, ...others];
                          getHoveredNotes(merged);
                        }}
                        onMouseLeave={() => setHoveredNotes([])}
                      >
                        <SmartTooltip
                          description={
                            Array.isArray(hoveredNotes) &&
                            hoveredNotes?.length > 0 ? (
                              <div className="flex flex-col gap-2">
                                {hoveredNotes?.map((hoveredNote, i) => (
                                  <p key={i}>
                                    "{hoveredNote?.note || ""}" by{" "}
                                    {formatWords2(
                                      hoveredNote?.addedBy?.firstName,
                                    ) || ""}{" "}
                                    on{" "}
                                    {dateFormator(
                                      convertFromUTC(hoveredNote?.addedOn),
                                      "datetime-ampm",
                                    ) || ""}
                                  </p>
                                ))}
                              </div>
                            ) : (
                              "Add note"
                            )
                          }
                          noicon
                        >
                          <DualIcon
                            icon="chat"
                            size="sm"
                            badgeIconColor={
                              existingCandidatesCB?.find((c) =>
                                (c?.resumeIds || []).some(
                                  (r) => String(r?.id) === String(data?.resumeId),
                                ),
                              )?.notes?.length > 0
                                ? "bg-success"
                                : "bg-dark"
                            }
                            onClick={() => {
                              const matchedObject = existingCandidatesCB?.find(
                                (c) =>
                                  (c?.resumeIds || []).some(
                                    (r) => String(r?.id) === String(data?.resumeId),
                                  ),
                              );

                              if (matchedObject) {
                                setNotesData(matchedObject);
                                setNotesModal(true);
                              }
                            }}
                          />
                        </SmartTooltip>
                      </div>
                    )}
                  </div>
                  <div className="text-[12px] text-neutrals-500 ">
                    {data?.jobTitle}
                  </div>
                  <div className="flex items-center gap-1 text-[14px] text-neutrals-500 mt-1">
                    <span className="material-icons !text-[16px]">
                      location_on
                    </span>
                    {data?.location}
                    {/* add location dynamically */}
                  </div>

                  {/* Tags */}
                  <div className="flex flex-wrap gap-2 mt-2">
                    <span className="text-xs bg-primary-50 text-black px-2 py-1 rounded-md border border-primary-200">
                      Recent Position: {data?.jobTitle}{" "}
                      {/* add position dynamically */}
                    </span>
                    <span className="text-xs bg-primary-50 text-black px-2 py-1 rounded-md border border-primary-200">
                      Experience: {data?.experience}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex justify-center py-8">
          <NoData />
        </div>
      )}
      <AddNoteModal
       key={noteData?.candidateId?.uiid || noteData?.uiid}
        isOpen={noteModal}
        onClose={() => setNotesModal(false)}
        data={noteData}
        source={source}
      />
    </div>
  );
};

export default TableGridToggleView;
